import { enumFillMode, enumElementBorderStyle, enumDashStyle } from "../constants";
import { XML_AdjustLineWidth } from "./XML_AdjustLineWidth";
import { XML_ShiftRect } from "./XML_ShiftRect";
import { XML_Cmd4 } from "./XML_Cmd4";
import { XML_CreateBoxPath } from "./XML_CreateBoxPath";
import { XML_GetDashParam } from "./XML_GetDashParam";
import { XML_Cmd2 } from "./XML_Cmd2";
import { XML_Param6 } from "./XML_Param6";

export function XML_RenderChartBoxPDF(
  bounds,
  outerBounds,
  boxShape,
  fillMode,
  fillColor,
  borderStyle,
  borderThickness,
  borderColor,
  dashStyle,
  shadow,
  drawElement,
  theLayer,
  backColor,
  fillAlpha
) {
  XML_ShiftRect(bounds, drawElement, theLayer);
  XML_ShiftRect(outerBounds, drawElement, theLayer);

  bounds.fTop = drawElement.ConvertY(bounds.fTop);
  bounds.fBottom = drawElement.ConvertY(bounds.fBottom);

  outerBounds.fTop = drawElement.ConvertY(outerBounds.fTop);
  outerBounds.fBottom = drawElement.ConvertY(outerBounds.fBottom);

  var double = borderStyle == enumElementBorderStyle.doubleBorder;

  if (shadow) {
    var sBounds, borderAdj;
    if (double) {
      borderAdj = XML_AdjustLineWidth(1, drawElement, theLayer);
      sBounds = outerBounds.Clone();
    } else {
      borderAdj = XML_AdjustLineWidth(1, drawElement, theLayer);
      sBounds = bounds.Clone();
    }

    sBounds.Shift(2 + borderAdj, -2 - borderAdj);
    XML_CreateBoxPath(sBounds, boxShape, drawElement);
    XML_Cmd2("fi", "#D0D0D0", "0.5", drawElement);
  }

  var dashed = dashStyle != enumDashStyle.nodash;

  var theBounds;
  if (fillMode == enumFillMode.solidFill) {
    theBounds = bounds;
    if (double) {
      theBounds = outerBounds;
    }
    XML_CreateBoxPath(theBounds, boxShape, drawElement);
    XML_Cmd2("fi", fillColor, fillAlpha ? fillAlpha : 1, drawElement);
  } else if (fillMode == enumFillMode.linearGradientDown) {
    XML_CreateBoxPath(bounds, boxShape, drawElement);
    XML_Param6(
      "cm",
      "grd",
      fillColor,
      backColor,
      bounds.fLeft,
      bounds.fTop,
      bounds.fTop - bounds.fBottom,
      drawElement
    );
  }
  if (borderStyle != enumElementBorderStyle.noBorder) {
    //XML_SetLineWidth(borderThickness, drawElement);
    XML_CreateBoxPath(bounds, boxShape, drawElement);
    if (dashed && !double) {
      var p = XML_GetDashParam(borderThickness);
      XML_Cmd4("stk", borderColor, borderThickness, p.fX, p.fY, drawElement);
    }
    //  XML_SetDashLine(borderThickness,drawElement);
    else XML_Cmd2("stk", borderColor, borderThickness, drawElement);
  }

  if (double) {
    XML_CreateBoxPath(outerBounds, boxShape, drawElement);
    //XML_Cmd1("fi","#FFFFFF",drawElement);
    //XML_SetLineWidth(1, drawElement);
    //if (dashed)
    //    XML_SetDashLine(borderThickness,drawElement);

    if (dashed) {
      var p = XML_GetDashParam(1);
      XML_Cmd4("stk", borderColor, 1, p.fX, p.fY, drawElement);
    } else XML_Cmd2("stk", borderColor, 1, drawElement);
  }
}
